















































































































































































import PageHeader from "@/components/PageHeader.vue";
import { Vue, Component, Watch } from "vue-property-decorator";
import { Action, State, Getter } from "vuex-class";
import moment from "moment";
import Callback from "@/components/Call/Callback.vue";
import * as api from "@/lib/api";
import LeadPanel from "@/components/Lead/LeadPanel.vue";
import { User } from "@/types";
import { getUserId } from "@/helpers";
import logger from "../configs/logger";
import { Routes } from "@/router/routes";

@Component({ components: { PageHeader, LeadPanel, Callback } })
export default class Leads extends Vue {
  @Action("getCallHistory") getCallHistory!: Function;
  @Action("getLead") getLead!: Function;
  @State("user") user!: User;
  @State("inCallMode") inCallMode!: boolean;

  activeLeadId: string = "";
  totalLeads = 0;
  loading = false;
  dialog = false;
  leads = [];
  filter: { [key: string]: any } = {
    q: "",
    create_date: [
      moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD")
    ],
    sale_date: [],
    sale_status: "",
    limit: 10,
    key: ""
  };
  nextKey = "";
  prevKey = "";
  limitOptions = [10, 20, 40];
  saleStatusOptions = [
    {
      value: "failed",
      name: "Failed"
    },
    {
      value: "sale",
      name: "Sale"
    },
    {
      value: "post_date",
      name: "Post Date"
    }
  ];
  disableSaleDate = true;
  disableCreateDate = false;
  headers = [
    { text: "First Name", value: "first_name" },
    { text: "Last Name", value: "last_name" },
    { text: "Phone Number", value: "phone_number" },
    { text: "Cost", value: "cost" },
    { text: "Sale Status", value: "sale_status" },
    { text: "Assigned Agent", value: "assigned_agent" },
    { text: "Lead Source", value: "lead_source" },
    { text: "Created Date", value: "create_timestamp" },
    { text: "Sale Date", value: "sale_date" },
    { text: "View Lead", value: "firestore_alternate_id" }
  ];
  newCost = "";
  snack = false;
  snackColor = "";
  snackText = "";

  open(cost: string) {
    this.newCost = cost;
  }

  async save(id: string, lead_cost: string) {
    if (this.isAdmin) {
      const success = await this.updateLeadCost(
        parseInt(id),
        parseFloat(this.newCost)
      );
      if (success) {
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Cost updated";
        this.loadLeads();
      }
    } else {
      this.$toasted.error("Admin access only").goAway(2000);
    }
  }

  async updateLeadCost(id: number, cost: number) {
    try {
      this.loading = true;
      await api.adminUpdateLeadCost(id, cost);
      return true;
    } catch (err) {
      logger("error", "cost update error", err);
      // @ts-ignore
      if (err.response.data.error) {
        this.$toasted.error(err.response.data.error).goAway(2000);
      } else {
        this.$toasted.error("cost update error").goAway(2000);
      }
      return false;
    } finally {
      this.loading = false;
    }
  }

  @Watch("inCallMode")
  onCallModeChange(val: any, preVal: any) {
    if (val) this.dialog = false;
  }

  @Watch("pagination", { deep: true })
  onPaginationChange(pagination: any) {
    logger("info", pagination);
  }

  @Watch("filter", { deep: true })
  onFilterChange(filter: any) {
    if (Array.isArray(filter.create_date) && filter.create_date.length === 2) {
      this.disableSaleDate = true;
      this.loadLeads();
    }
    if (Array.isArray(filter.sale_date) && filter.sale_date.length === 2) {
      this.disableCreateDate = true;
      this.loadLeads();
    }
    this.loadLeads();
  }

  get filterDateCreatedText() {
    return this.filter.create_date.join(" ~ ");
  }

  get filterSaleDateText() {
    return this.filter.sale_date.join(" ~ ");
  }

  get getMinDate() {
    if (this.isAdmin) {
      return null;
    } else if (this.isCloser) {
      return moment()
        .subtract(4, "weeks")
        .format("YYYY-MM-DD");
    } else if (this.isFronter) {
      return moment()
        .subtract(1, "weeks")
        .format("YYYY-MM-DD");
    }

    return null;
  }

  get getMaxDate() {
    return moment().format("YYYY-MM-DD");
  }

  get isAdmin() {
    return this.user.roles && this.user.roles.includes("admin");
  }

  get isCloser() {
    return this.user.roles.includes("closer");
  }

  get isFronter() {
    return this.user.roles.includes("fronter");
  }

  renderDateFormat(date: string) {
    return moment(date).format("YYYY-MM-DD");
  }

  handlePreviousPage() {
    this.loadLeads(this.prevKey);
  }

  handleNextPage() {
    this.loadLeads(this.nextKey);
  }

  onFilterClear(name: string) {
    if (name === "create_date") {
      this.disableSaleDate = false;
    }
    if (name === "sale_date") {
      this.disableCreateDate = false;
    }
    this.filter[name] = [];
  }

  onChangeLimit(val: string) {
    this.filter.limit = val;
  }

  selectSaleStatus(val: string) {
    this.filter.sale_status = val;
  }

  mounted() {
    this.loadLeads();
  }

  openLookup() {
    this.$router.push({ name: Routes.LookupLead });
  }

  cleanObject(obj: { [key: string]: any }) {
    const cleanObject = obj;
    for (var propName in cleanObject) {
      if (
        cleanObject[propName] === null ||
        cleanObject[propName] === undefined ||
        cleanObject[propName] === ""
      ) {
        delete cleanObject[propName];
      }
    }
    return cleanObject;
  }

  async handleViewLead(leadId: string) {
    this.activeLeadId = leadId;
    this.dialog = true;
  }

  async loadLeads(key?: String) {
    try {
      this.loading = true;
      const start_date = this.filter.create_date[0]
        ? moment.utc(this.filter.create_date[0]).format("YYYY-MM-DDTHH:mm:ss")
        : undefined;

      const end_date = this.filter.create_date[1]
        ? moment.utc(this.filter.create_date[1]).format("YYYY-MM-DDTHH:mm:ss")
        : undefined;

      const sale_date_start = this.filter.sale_date[0]
        ? moment.utc(this.filter.sale_date[0]).format("YYYY-MM-DDTHH:mm:ss")
        : undefined;

      const sale_date_end = this.filter.sale_date[1]
        ? moment.utc(this.filter.sale_date[1]).format("YYYY-MM-DDTHH:mm:ss")
        : undefined;

      const query: { [key: string]: any } = {
        limit: this.filter.limit,
        sale_status: this.filter.sale_status,
        sale_date_start,
        sale_date_end,
        start_date,
        end_date,
        q: this.filter.q
      };

      if (key) {
        query.key = key;
      }

      const { data } = await api.adminGetLeads(this.cleanObject(query));
      this.nextKey = data.next_page_key;
      this.prevKey = data.previous_page_key;
      this.leads = data.data;
    } catch (err) {
      // @ts-ignore
      if (err.response.data.error) {
        this.$toasted.error(err.response.data.error).goAway(2000);
      } else {
        this.$toasted.error("Lead lookup error").goAway(2000);
      }
    } finally {
      this.loading = false;
    }
  }
}
